import { render } from "./HowToConfigs.vue?vue&type=template&id=f4809acc"
import script from "./HowToConfigs.vue?vue&type=script&lang=js"
export * from "./HowToConfigs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__